{
  "AED": {
    "name": "United Arab Emirates Dirham",
    "demonym": "UAE",
    "majorSingle": "Dirham",
    "majorPlural": "Dirhams",
    "symbol": "د.إ.",
    "symbolNative": "د.إ.",
    "symbolPreferred": "د.إ.",
    "minorSingle": "Fils",
    "minorPlural": "Fils",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "AFN": {
    "name": "Afghan Afghani",
    "demonym": "Afghan",
    "majorSingle": "Afghani",
    "majorPlural": "Afghani",
    "symbol": "Af",
    "symbolNative": "؋",
    "symbolPreferred": "؋",
    "minorSingle": "Pul",
    "minorPlural": "Pul",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "ALL": {
    "name": "Albanian Lek",
    "demonym": "Albanian",
    "majorSingle": "Lek",
    "majorPlural": "Lekë",
    "symbol": "L",
    "symbolNative": "L",
    "symbolPreferred": "L",
    "minorSingle": "Qindarka",
    "minorPlural": "Qindarka",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "AMD": {
    "name": "Armenian Dram",
    "demonym": "Armenian",
    "majorSingle": "Dram",
    "majorPlural": "Dram",
    "symbol": "֏",
    "symbolNative": "դր",
    "symbolPreferred": "դր",
    "minorSingle": "Luma",
    "minorPlural": "Luma",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "AOA": {
    "name": "Angolan Kwanza",
    "demonym": "Angolan",
    "majorSingle": "Kwanza",
    "majorPlural": "Kwanza",
    "symbol": "Kz",
    "symbolNative": "Kz",
    "symbolPreferred": "Kz",
    "minorSingle": "Centimo",
    "minorPlural": "Centimos",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "ARS": {
    "name": "Argentine Peso",
    "demonym": "Argentine",
    "majorSingle": "Peso",
    "majorPlural": "Pesos",
    "symbol": "AR$",
    "symbolNative": "$",
    "symbolPreferred": "$",
    "minorSingle": "Centavo",
    "minorPlural": "Centavos",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "AUD": {
    "name": "Australian Dollar",
    "demonym": "Australian",
    "majorSingle": "Dollar",
    "majorPlural": "Dollars",
    "symbol": "AU$",
    "symbolNative": "$",
    "symbolPreferred": "$",
    "minorSingle": "Cent",
    "minorPlural": "Cents",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "AWG": {
    "name": "Aruban Florin",
    "demonym": "Aruban",
    "majorSingle": "Florin",
    "majorPlural": "Florin",
    "symbol": "ƒ",
    "symbolNative": "ƒ",
    "symbolPreferred": "ƒ",
    "minorSingle": "Cent",
    "minorPlural": "Cents",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "AZN": {
    "name": "Azerbaijani Manat",
    "demonym": "Azerbaijani",
    "majorSingle": "Manat",
    "majorPlural": "Manat",
    "symbol": "ман",
    "symbolNative": "₼",
    "symbolPreferred": "₼",
    "minorSingle": "Qapik",
    "minorPlural": "Qapik",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "BAM": {
    "name": "Bosnia and Herzegovina Convertible Mark",
    "demonym": "Bosnia-Herzegovina",
    "majorSingle": "Convertible Mark",
    "majorPlural": "Marks",
    "symbol": "KM",
    "symbolNative": "КМ",
    "symbolPreferred": "КМ",
    "minorSingle": "Fening",
    "minorPlural": "Fening",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "BBD": {
    "name": "Barbadian Dollar",
    "demonym": "Barbadian",
    "majorSingle": "Dollar",
    "majorPlural": "Dollars",
    "symbol": "BBD$",
    "symbolNative": "$",
    "symbolPreferred": "$",
    "minorSingle": "Cent",
    "minorPlural": "Cents",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "BDT": {
    "name": "Bangladeshi Taka",
    "demonym": "Bangladeshi",
    "majorSingle": "Taka",
    "majorPlural": "Taka",
    "symbol": "৳",
    "symbolNative": "Tk",
    "symbolPreferred": "Tk",
    "minorSingle": "Poisha",
    "minorPlural": "Poisha",
    "decimals": 2,
    "decimalsCompact": 0,
    "digitGrouping": 2
  },
  "BGN": {
    "name": "Bulgarian Lev",
    "demonym": "Bulgarian",
    "majorSingle": "Lev",
    "majorPlural": "Leva",
    "symbol": "лв.",
    "symbolNative": "лв.",
    "symbolPreferred": "лв.",
    "minorSingle": "Stotinka",
    "minorPlural": "Stotinki",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "BHD": {
    "name": "Bahraini Dinar",
    "demonym": "Bahraini",
    "majorSingle": "Dinar",
    "majorPlural": "Dinars",
    "symbol": "BD",
    "symbolNative": "د.ب.",
    "symbolPreferred": "د.ب.",
    "minorSingle": "Fils",
    "minorPlural": "Fils",
    "decimals": 3,
    "decimalsCompact": 3,
    "digitGrouping": 3
  },
  "BIF": {
    "name": "Burundian Franc",
    "demonym": "Burundian",
    "majorSingle": "Franc",
    "majorPlural": "Francs",
    "symbol": "FBu",
    "symbolNative": "FBu",
    "symbolPreferred": "FBu",
    "minorSingle": "Centime",
    "minorPlural": "Centimes",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "BMD": {
    "name": "Bermudian Dollar",
    "demonym": "Bermudian",
    "majorSingle": "Dollar",
    "majorPlural": "Dollars",
    "symbol": "$",
    "symbolNative": "$",
    "symbolPreferred": "$",
    "minorSingle": "Cent",
    "minorPlural": "Cents",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "BND": {
    "name": "Brunei Dollar",
    "demonym": "Brunei",
    "majorSingle": "Dollar",
    "majorPlural": "Dollars",
    "symbol": "B$",
    "symbolNative": "$",
    "symbolPreferred": "$",
    "minorSingle": "Cent",
    "minorPlural": "Cents",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "BOB": {
    "name": "Bolivian Boliviano",
    "demonym": "Bolivian",
    "majorSingle": "Boliviano",
    "majorPlural": "Bolivianos",
    "symbol": "Bs.",
    "symbolNative": "Bs.",
    "symbolPreferred": "Bs.",
    "minorSingle": "Centavo",
    "minorPlural": "Centavos",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "BRL": {
    "name": "Brazilian Real",
    "demonym": "Brazilian",
    "majorSingle": "Real",
    "majorPlural": "Reais",
    "symbol": "R$",
    "symbolNative": "R$",
    "symbolPreferred": "R$",
    "minorSingle": "Centavo",
    "minorPlural": "Centavos",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "BSD": {
    "name": "Bahamian Dollar",
    "demonym": "Bahamian",
    "majorSingle": "Dollar",
    "majorPlural": "Dollars",
    "symbol": "$",
    "symbolNative": "$",
    "symbolPreferred": "$",
    "minorSingle": "Cent",
    "minorPlural": "Cents",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "BTN": {
    "name": "Bhutanese Ngultrum",
    "demonym": "Bhutanese",
    "majorSingle": "Ngultrum",
    "majorPlural": "Ngultrums",
    "symbol": "Nu.",
    "symbolNative": "Nu.",
    "symbolPreferred": "Nu.",
    "minorSingle": "Chetrum",
    "minorPlural": "Chetrums",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "BWP": {
    "name": "Botswana Pula",
    "demonym": "Botswana",
    "majorSingle": "Pula",
    "majorPlural": "Pula",
    "symbol": "P",
    "symbolNative": "P",
    "symbolPreferred": "P",
    "minorSingle": "Thebe",
    "minorPlural": "Thebe",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "BYR": {
    "name": "Belarusian Ruble",
    "demonym": "Belarusian",
    "majorSingle": "Ruble",
    "majorPlural": "Rubles",
    "symbol": "p.",
    "symbolNative": "p.",
    "symbolPreferred": "p.",
    "minorSingle": "Kapeyka",
    "minorPlural": "Kapeyka",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "BZD": {
    "name": "Belize Dollar",
    "demonym": "Belize",
    "majorSingle": "Dollar",
    "majorPlural": "Dollars",
    "symbol": "BZ$",
    "symbolNative": "$",
    "symbolPreferred": "$",
    "minorSingle": "Cent",
    "minorPlural": "Cents",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "CAD": {
    "name": "Canadian Dollar",
    "demonym": "Canadian",
    "majorSingle": "Dollar",
    "majorPlural": "Dollars",
    "symbol": "CA$",
    "symbolNative": "$",
    "symbolPreferred": "$",
    "minorSingle": "Cent",
    "minorPlural": "Cents",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "CDF": {
    "name": "Congolese Franc",
    "demonym": "Congolese",
    "majorSingle": "Franc",
    "majorPlural": "Francs",
    "symbol": "FC",
    "symbolNative": "₣",
    "symbolPreferred": "₣",
    "minorSingle": "Centime",
    "minorPlural": "Centimes",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "CHF": {
    "name": "Swiss Franc",
    "demonym": "Swiss",
    "majorSingle": "Franc",
    "majorPlural": "Francs",
    "symbol": "Fr.",
    "symbolNative": "₣",
    "symbolPreferred": "₣",
    "minorSingle": "Centime",
    "minorPlural": "Centimes",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "CLP": {
    "name": "Chilean Peso",
    "demonym": "Chilean",
    "majorSingle": "Peso",
    "majorPlural": "Pesos",
    "symbol": "CL$",
    "symbolNative": "$",
    "symbolPreferred": "$",
    "minorSingle": "Centavo",
    "minorPlural": "Centavos",
    "decimals": 0,
    "decimalsCompact": 0,
    "digitGrouping": 3
  },
  "CNY": {
    "name": "Chinese Yuan",
    "demonym": "Chinese",
    "majorSingle": "Yuan",
    "majorPlural": "Yuan",
    "symbol": "CN¥",
    "symbolNative": "¥元",
    "symbolPreferred": "¥元",
    "minorSingle": "Fen",
    "minorPlural": "Fen",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "COP": {
    "name": "Colombian Peso",
    "demonym": "Colombian",
    "majorSingle": "Peso",
    "majorPlural": "Pesos",
    "symbol": "CO$",
    "symbolNative": "$",
    "symbolPreferred": "$",
    "minorSingle": "Centavo",
    "minorPlural": "Centavos",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "CRC": {
    "name": "Costa Rican Colon",
    "demonym": "Costa Rican",
    "majorSingle": "Colón",
    "majorPlural": "Colones",
    "symbol": "₡",
    "symbolNative": "₡",
    "symbolPreferred": "₡",
    "minorSingle": "Centimo",
    "minorPlural": "Centimos",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "CUP": {
    "name": "Cuban Peso",
    "demonym": "Cuban",
    "majorSingle": "Peso",
    "majorPlural": "Pesos",
    "symbol": "$MN",
    "symbolNative": "₱",
    "symbolPreferred": "₱",
    "minorSingle": "Centavo",
    "minorPlural": "Centavos",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "CVE": {
    "name": "Cabo Verdean Escudo",
    "demonym": "Cabo Verdean",
    "majorSingle": "Escudo",
    "majorPlural": "Escudo",
    "symbol": "CV$",
    "symbolNative": "$",
    "symbolPreferred": "$",
    "minorSingle": "Centavo",
    "minorPlural": "Centavos",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "CZK": {
    "name": "Czech Koruna",
    "demonym": "Czech",
    "majorSingle": "Koruna",
    "majorPlural": "Koruny",
    "symbol": "Kč",
    "symbolNative": "Kč",
    "symbolPreferred": "Kč",
    "minorSingle": "Haléř",
    "minorPlural": "Haléř",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "DJF": {
    "name": "Djiboutian Franc",
    "demonym": "Djiboutian",
    "majorSingle": "Franc",
    "majorPlural": "Francs",
    "symbol": "Fdj",
    "symbolNative": "ف.ج.",
    "symbolPreferred": "ف.ج.",
    "minorSingle": "Centime",
    "minorPlural": "Centimes",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "DKK": {
    "name": "Danish Krone",
    "demonym": "Danish",
    "majorSingle": "Krone",
    "majorPlural": "Kroner",
    "symbol": "kr.",
    "symbolNative": "kr.",
    "symbolPreferred": "kr.",
    "minorSingle": "Øre",
    "minorPlural": "Øre",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "DOP": {
    "name": "Dominican Peso",
    "demonym": "Dominican",
    "majorSingle": "Peso",
    "majorPlural": "Pesos",
    "symbol": "RD$",
    "symbolNative": "$",
    "symbolPreferred": "$",
    "minorSingle": "Centavo",
    "minorPlural": "Centavos",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "DZD": {
    "name": "Algerian Dinar",
    "demonym": "Algerian",
    "majorSingle": "Dinar",
    "majorPlural": "Dinars",
    "symbol": "DA",
    "symbolNative": "د.ج.",
    "symbolPreferred": "د.ج.",
    "minorSingle": "Santeem",
    "minorPlural": "Santeems",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "EGP": {
    "name": "Egyptian Pound",
    "demonym": "Egyptian",
    "majorSingle": "Pound",
    "majorPlural": "Pounds",
    "symbol": "E£",
    "symbolNative": "ج.م.",
    "symbolPreferred": "ج.م.",
    "minorSingle": "Qirsh",
    "minorPlural": "Qirsh",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "ERN": {
    "name": "Eritrean Nakfa",
    "demonym": "Eritrean",
    "majorSingle": "Nakfa",
    "majorPlural": "Nakfa",
    "symbol": "Nkf",
    "symbolNative": "ناكفا",
    "symbolPreferred": "ناكفا",
    "minorSingle": "Cent",
    "minorPlural": "Cents",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "ETB": {
    "name": "Ethiopian Birr",
    "demonym": "Ethiopian",
    "majorSingle": "Birr",
    "majorPlural": "Birr",
    "symbol": "Br",
    "symbolNative": "ብር",
    "symbolPreferred": "ብር",
    "minorSingle": "Santim",
    "minorPlural": "Santim",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "EUR": {
    "name": "Euro",
    "demonym": "",
    "majorSingle": "Euro",
    "majorPlural": "Euros",
    "symbol": "€",
    "symbolNative": "€",
    "symbolPreferred": "€",
    "minorSingle": "Cent",
    "minorPlural": "Cents",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "FJD": {
    "name": "Fijian Dollar",
    "demonym": "Fijian",
    "majorSingle": "Dollar",
    "majorPlural": "Dollars",
    "symbol": "FJ$",
    "symbolNative": "$",
    "symbolPreferred": "$",
    "minorSingle": "Cent",
    "minorPlural": "Cents",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "FKP": {
    "name": "Falkland Islands Pound",
    "demonym": "Falkland Islands",
    "majorSingle": "Pound",
    "majorPlural": "Pounds",
    "symbol": "FK£",
    "symbolNative": "£",
    "symbolPreferred": "£",
    "minorSingle": "Penny",
    "minorPlural": "Pence",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "GBP": {
    "name": "Pound Sterling",
    "demonym": "Pound Sterling",
    "majorSingle": "Pound",
    "majorPlural": "Pounds",
    "symbol": "£",
    "symbolNative": "£",
    "symbolPreferred": "£",
    "minorSingle": "Penny",
    "minorPlural": "Pence",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "GEL": {
    "name": "Georgian Lari",
    "demonym": "Georgian",
    "majorSingle": "Lari",
    "majorPlural": "Lari",
    "symbol": "₾",
    "symbolNative": "₾",
    "symbolPreferred": "₾",
    "minorSingle": "Tetri",
    "minorPlural": "Tetri",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "GHS": {
    "name": "Ghanaian Cedi",
    "demonym": "Ghanaian",
    "majorSingle": "Cedi",
    "majorPlural": "Cedis",
    "symbol": "GH₵",
    "symbolNative": "₵",
    "symbolPreferred": "₵",
    "minorSingle": "Pesewa",
    "minorPlural": "Pesewas",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "GIP": {
    "name": "Gibraltar Pound",
    "demonym": "Gibraltar",
    "majorSingle": "Pound",
    "majorPlural": "Pounds",
    "symbol": "£",
    "symbolNative": "£",
    "symbolPreferred": "£",
    "minorSingle": "Penny",
    "minorPlural": "Pence",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "GMD": {
    "name": "Gambian Dalasi",
    "demonym": "Gambian",
    "majorSingle": "Dalasi",
    "majorPlural": "Dalasis",
    "symbol": "D",
    "symbolNative": "D",
    "symbolPreferred": "D",
    "minorSingle": "Butut",
    "minorPlural": "Bututs",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "GNF": {
    "name": "Guinean Franc",
    "demonym": "Guinean",
    "majorSingle": "Franc",
    "majorPlural": "Francs",
    "symbol": "FG",
    "symbolNative": "FG",
    "symbolPreferred": "FG",
    "minorSingle": "Centime",
    "minorPlural": "Centimes",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "GTQ": {
    "name": "Guatemalan Quetzal",
    "demonym": "Guatemalan",
    "majorSingle": "Quetzal",
    "majorPlural": "Quetzales",
    "symbol": "Q",
    "symbolNative": "$",
    "symbolPreferred": "$",
    "minorSingle": "Centavo",
    "minorPlural": "Centavos",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "GYD": {
    "name": "Guyanese Dollar",
    "demonym": "Guyanese",
    "majorSingle": "Dollar",
    "majorPlural": "Dollars",
    "symbol": "G$",
    "symbolNative": "$",
    "symbolPreferred": "$",
    "minorSingle": "Cent",
    "minorPlural": "Cents",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "HKD": {
    "name": "Hong Kong Dollar",
    "demonym": "Hong Kong",
    "majorSingle": "Dollar",
    "majorPlural": "Dollars",
    "symbol": "HK$",
    "symbolNative": "$",
    "symbolPreferred": "$",
    "minorSingle": "Cent",
    "minorPlural": "Cents",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "HNL": {
    "name": "Honduran Lempira",
    "demonym": "Honduran",
    "majorSingle": "Lempira",
    "majorPlural": "Lempiras",
    "symbol": "L",
    "symbolNative": "L",
    "symbolPreferred": "L",
    "minorSingle": "Centavo",
    "minorPlural": "Centavos",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "HRK": {
    "name": "Croatian Kuna",
    "demonym": "Croatian",
    "majorSingle": "Kuna",
    "majorPlural": "Kuna",
    "symbol": "kn",
    "symbolNative": "kn",
    "symbolPreferred": "kn",
    "minorSingle": "Lipa",
    "minorPlural": "Lipa",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "HTG": {
    "name": "Haitian Gourde",
    "demonym": "Haitian",
    "majorSingle": "Gourde",
    "majorPlural": "Gourdes",
    "symbol": "G",
    "symbolNative": "G",
    "symbolPreferred": "G",
    "minorSingle": "Centime",
    "minorPlural": "Centimes",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "HUF": {
    "name": "Hungarian Forint",
    "demonym": "Hungarian",
    "majorSingle": "Forint",
    "majorPlural": "Forint",
    "symbol": "Ft",
    "symbolNative": "Ft",
    "symbolPreferred": "Ft",
    "minorSingle": "fillér",
    "minorPlural": "fillér",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "IDR": {
    "name": "Indonesian Rupiah",
    "demonym": "Indonesian",
    "majorSingle": "Rupiah",
    "majorPlural": "Rupiah",
    "symbol": "Rp",
    "symbolNative": "Rp",
    "symbolPreferred": "Rp",
    "minorSingle": "Sen",
    "minorPlural": "Sen",
    "decimals": 2,
    "decimalsCompact": 0,
    "digitGrouping": 3
  },
  "ILS": {
    "name": "Israeli new Shekel",
    "demonym": "Israeli",
    "majorSingle": "Shekel",
    "majorPlural": "Shekels",
    "symbol": "₪",
    "symbolNative": "₪",
    "symbolPreferred": "₪",
    "minorSingle": "Agora",
    "minorPlural": "Agoras",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "INR": {
    "name": "Indian Rupee",
    "demonym": "Indian",
    "majorSingle": "Rupee",
    "majorPlural": "Rupees",
    "symbol": "Rs.",
    "symbolNative": "₹",
    "symbolPreferred": "₹",
    "minorSingle": "Paisa",
    "minorPlural": "Paise",
    "decimals": 2,
    "decimalsCompact": 0,
    "digitGrouping": 2
  },
  "IQD": {
    "name": "Iraqi Dinar",
    "demonym": "Iraqi",
    "majorSingle": "Dinar",
    "majorPlural": "Dinars",
    "symbol": "د.ع.",
    "symbolNative": "د.ع.",
    "symbolPreferred": "د.ع.",
    "minorSingle": "Fils",
    "minorPlural": "Fils",
    "decimals": 3,
    "decimalsCompact": 3,
    "digitGrouping": 2
  },
  "IRR": {
    "name": "Iranian Rial",
    "demonym": "Iranian",
    "majorSingle": "Rial",
    "majorPlural": "Rials",
    "symbol": "﷼",
    "symbolNative": "﷼",
    "symbolPreferred": "﷼",
    "minorSingle": "Dinar",
    "minorPlural": "Dinars",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "ISK": {
    "name": "Icelandic Krona",
    "demonym": "Icelandic",
    "majorSingle": "Krona",
    "majorPlural": "Krónur",
    "symbol": "kr",
    "symbolNative": "kr",
    "symbolPreferred": "kr",
    "minorSingle": "Aurar",
    "minorPlural": "Aurar",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "JMD": {
    "name": "Jamaican Dollar",
    "demonym": "Jamaican",
    "majorSingle": "Dollar",
    "majorPlural": "Dollars",
    "symbol": "J$",
    "symbolNative": "$",
    "symbolPreferred": "$",
    "minorSingle": "Cent",
    "minorPlural": "Cents",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "JOD": {
    "name": "Jordanian Dinar",
    "demonym": "Jordanian",
    "majorSingle": "Dinar",
    "majorPlural": "Dinars",
    "symbol": "JD",
    "symbolNative": "د.أ.",
    "symbolPreferred": "د.أ.",
    "minorSingle": "Fils",
    "minorPlural": "Fils",
    "decimals": 3,
    "decimalsCompact": 3,
    "digitGrouping": 3
  },
  "JPY": {
    "name": "Japanese Yen",
    "demonym": "Japanese",
    "majorSingle": "Yen",
    "majorPlural": "Yen",
    "symbol": "¥",
    "symbolNative": "¥",
    "symbolPreferred": "¥",
    "minorSingle": "Sen",
    "minorPlural": "Sen",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "KES": {
    "name": "Kenyan Shilling",
    "demonym": "Kenyan",
    "majorSingle": "Shilling",
    "majorPlural": "Shillings",
    "symbol": "KSh",
    "symbolNative": "KSh",
    "symbolPreferred": "KSh",
    "minorSingle": "Cent",
    "minorPlural": "Cents",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "KGS": {
    "name": "Kyrgyzstani Som",
    "demonym": "Kyrgyzstani",
    "majorSingle": "Som",
    "majorPlural": "Som",
    "symbol": "с",
    "symbolNative": "с",
    "symbolPreferred": "с",
    "minorSingle": "Tyiyn",
    "minorPlural": "Tyiyn",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "KHR": {
    "name": "Cambodian Riel",
    "demonym": "Cambodian",
    "majorSingle": "Riel",
    "majorPlural": "Riels",
    "symbol": "៛",
    "symbolNative": "៛",
    "symbolPreferred": "៛",
    "minorSingle": "Sen",
    "minorPlural": "Sen",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "KMF": {
    "name": "Comorian Franc",
    "demonym": "Comorian",
    "majorSingle": "Franc",
    "majorPlural": "Francs",
    "symbol": "CF",
    "symbolNative": "CF",
    "symbolPreferred": "CF",
    "minorSingle": "Centime",
    "minorPlural": "Centimes",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "KPW": {
    "name": "North Korean Won",
    "demonym": "North Korean",
    "majorSingle": "Won",
    "majorPlural": "Won",
    "symbol": "₩",
    "symbolNative": "₩",
    "symbolPreferred": "₩",
    "minorSingle": "Chon",
    "minorPlural": "Chon",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "KRW": {
    "name": "South Korean Won",
    "demonym": "South Korean",
    "majorSingle": "Won",
    "majorPlural": "Won",
    "symbol": "₩",
    "symbolNative": "₩",
    "symbolPreferred": "₩",
    "minorSingle": "Jeon",
    "minorPlural": "Jeon",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "KWD": {
    "name": "Kuwaiti Dinar",
    "demonym": "Kuwaiti",
    "majorSingle": "Dinar",
    "majorPlural": "Dinars",
    "symbol": "KD",
    "symbolNative": "د.ك.",
    "symbolPreferred": "د.ك.",
    "minorSingle": "Fils",
    "minorPlural": "Fils",
    "decimals": 3,
    "decimalsCompact": 3,
    "digitGrouping": 3
  },
  "KYD": {
    "name": "Cayman Islands Dollar",
    "demonym": "Cayman Islands",
    "majorSingle": "Dollar",
    "majorPlural": "Dollars",
    "symbol": "CI$",
    "symbolNative": "$",
    "symbolPreferred": "$",
    "minorSingle": "Cent",
    "minorPlural": "Cents",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "KZT": {
    "name": "Kazakhstani Tenge",
    "demonym": "Kazakhstani",
    "majorSingle": "Tenge",
    "majorPlural": "Tenge",
    "symbol": "₸",
    "symbolNative": "₸",
    "symbolPreferred": "₸",
    "minorSingle": "Tıyn",
    "minorPlural": "Tıyn",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "LAK": {
    "name": "Lao Kip",
    "demonym": "Lao",
    "majorSingle": "Kip",
    "majorPlural": "Kip",
    "symbol": "₭N",
    "symbolNative": "₭",
    "symbolPreferred": "₭",
    "minorSingle": "Att",
    "minorPlural": "Att",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "LBP": {
    "name": "Lebanese Pound",
    "demonym": "Lebanese",
    "majorSingle": "Pound",
    "majorPlural": "Pounds",
    "symbol": "LL.",
    "symbolNative": "LL",
    "symbolPreferred": "LL",
    "minorSingle": "Qirsh",
    "minorPlural": "Qirsh",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "LKR": {
    "name": "Sri Lankan Rupee",
    "demonym": "Sri Lankan",
    "majorSingle": "Rupee",
    "majorPlural": "Rupees",
    "symbol": "Rs.",
    "symbolNative": "රු or ரூ",
    "symbolPreferred": "රු or ரூ",
    "minorSingle": "Cent",
    "minorPlural": "Cents",
    "decimals": 2,
    "decimalsCompact": 0,
    "digitGrouping": 2
  },
  "LRD": {
    "name": "Liberian Dollar",
    "demonym": "Liberian",
    "majorSingle": "Dollar",
    "majorPlural": "Dollars",
    "symbol": "L$",
    "symbolNative": "$",
    "symbolPreferred": "$",
    "minorSingle": "Cent",
    "minorPlural": "Cents",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "LSL": {
    "name": "Lesotho Loti",
    "demonym": "Lesotho",
    "majorSingle": "Loti",
    "majorPlural": "maLoti",
    "symbol": "L",
    "symbolNative": "L",
    "symbolPreferred": "L",
    "minorSingle": "Sente",
    "minorPlural": "Lisente",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "LTL": {
    "name": "Lithuanian Litas",
    "demonym": "Lithuanian",
    "majorSingle": "Litas",
    "majorPlural": "Litas",
    "symbol": "Lt",
    "symbolNative": "Lt",
    "symbolPreferred": "Lt",
    "minorSingle": "Centas",
    "minorPlural": "Centas",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "LYD": {
    "name": "Libyan Dinar",
    "demonym": "Libyan",
    "majorSingle": "Dinar",
    "majorPlural": "Dinars",
    "symbol": "LD",
    "symbolNative": "ل.د.",
    "symbolPreferred": "ل.د.",
    "minorSingle": "Dirham",
    "minorPlural": "Dirhams",
    "decimals": 3,
    "decimalsCompact": 3,
    "digitGrouping": 3
  },
  "MAD": {
    "name": "Moroccan Dirham",
    "demonym": "Moroccan",
    "majorSingle": "Dirham",
    "majorPlural": "Dirhams",
    "symbol": "DH",
    "symbolNative": "د.م.",
    "symbolPreferred": "د.م.",
    "minorSingle": "Centime",
    "minorPlural": "Centimes",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "MDL": {
    "name": "Moldovan Leu",
    "demonym": "Moldovan",
    "majorSingle": "Leu",
    "majorPlural": "Lei",
    "symbol": "L",
    "symbolNative": "L",
    "symbolPreferred": "L",
    "minorSingle": "Ban",
    "minorPlural": "Bani",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "MGA": {
    "name": "Malagasy Ariary",
    "demonym": "Malagasy",
    "majorSingle": "Ariary",
    "majorPlural": "Ariary",
    "symbol": "Ar",
    "symbolNative": "Ar",
    "symbolPreferred": "Ar",
    "minorSingle": "Iraimbilanja",
    "minorPlural": "Iraimbilanja",
    "decimals": 0,
    "decimalsCompact": 0,
    "digitGrouping": 3
  },
  "MKD": {
    "name": "Macedonian Denar",
    "demonym": "Macedonian",
    "majorSingle": "Denar",
    "majorPlural": "Denars",
    "symbol": "den",
    "symbolNative": "ден",
    "symbolPreferred": "ден",
    "minorSingle": "Deni",
    "minorPlural": "Deni",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "MMK": {
    "name": "Myanmar Kyat",
    "demonym": "Myanmar",
    "majorSingle": "Kyat",
    "majorPlural": "Kyat",
    "symbol": "Ks",
    "symbolNative": "Ks",
    "symbolPreferred": "Ks",
    "minorSingle": "Pya",
    "minorPlural": "Pya",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "MNT": {
    "name": "Mongolian Tögrög",
    "demonym": "Mongolian",
    "majorSingle": "Tögrög",
    "majorPlural": "Tögrög",
    "symbol": "₮",
    "symbolNative": "₮",
    "symbolPreferred": "₮",
    "minorSingle": "möngö",
    "minorPlural": "möngö",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "MOP": {
    "name": "Macanese Pataca",
    "demonym": "Macanese",
    "majorSingle": "Pataca",
    "majorPlural": "Patacas",
    "symbol": "MOP$",
    "symbolNative": "MOP$",
    "symbolPreferred": "MOP$",
    "minorSingle": "Avo",
    "minorPlural": "Avos",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "MRO": {
    "name": "Mauritanian Ouguiya",
    "demonym": "Mauritanian",
    "majorSingle": "Ouguiya",
    "majorPlural": "Ouguiyas",
    "symbol": "UM",
    "symbolNative": "UM",
    "symbolPreferred": "UM",
    "minorSingle": "Khoum",
    "minorPlural": "Khoums",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "MUR": {
    "name": "Mauritian Rupee",
    "demonym": "Mauritian",
    "majorSingle": "Rupee",
    "majorPlural": "Rupees",
    "symbol": "Rs.",
    "symbolNative": "रु ",
    "symbolPreferred": "रु ",
    "minorSingle": "Cent",
    "minorPlural": "Cents",
    "decimals": 2,
    "decimalsCompact": 0,
    "digitGrouping": 3
  },
  "MVR": {
    "name": "Maldivian Rufiyaa",
    "demonym": "Maldivian",
    "majorSingle": "Rufiyaa",
    "majorPlural": "Rufiyaa",
    "symbol": "MRf",
    "symbolNative": ".ރ",
    "symbolPreferred": ".ރ",
    "minorSingle": "laari",
    "minorPlural": "laari",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "MWK": {
    "name": "Malawian Kwacha",
    "demonym": "Malawian",
    "majorSingle": "Kwacha",
    "majorPlural": "Kwacha",
    "symbol": "MK",
    "symbolNative": "MK",
    "symbolPreferred": "MK",
    "minorSingle": "Tambala",
    "minorPlural": "Tambala",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "MXN": {
    "name": "Mexican Peso",
    "demonym": "Mexican",
    "majorSingle": "Peso",
    "majorPlural": "Pesos",
    "symbol": "MX$",
    "symbolNative": "$",
    "symbolPreferred": "$",
    "minorSingle": "Centavo",
    "minorPlural": "Centavos",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "MYR": {
    "name": "Malaysian Ringgit",
    "demonym": "Malaysian",
    "majorSingle": "Ringgit",
    "majorPlural": "Ringgit",
    "symbol": "RM",
    "symbolNative": "RM",
    "symbolPreferred": "RM",
    "minorSingle": "Sen",
    "minorPlural": "Sen",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "MZN": {
    "name": "Mozambican Metical",
    "demonym": "Mozambican",
    "majorSingle": "Metical",
    "majorPlural": "Meticais",
    "symbol": "MTn",
    "symbolNative": "MT",
    "symbolPreferred": "MT",
    "minorSingle": "Centavo",
    "minorPlural": "Centavos",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "NAD": {
    "name": "Namibian Dollar",
    "demonym": "Namibian",
    "majorSingle": "Dollar",
    "majorPlural": "Dollars",
    "symbol": "N$",
    "symbolNative": "$",
    "symbolPreferred": "$",
    "minorSingle": "Cent",
    "minorPlural": "Cents",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "NGN": {
    "name": "Nigerian Naira",
    "demonym": "Nigerian",
    "majorSingle": "Naira",
    "majorPlural": "Naira",
    "symbol": "₦",
    "symbolNative": "₦",
    "symbolPreferred": "₦",
    "minorSingle": "Kobo",
    "minorPlural": "Kobo",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "NIO": {
    "name": "Nicaraguan Córdoba",
    "demonym": "Nicaraguan",
    "majorSingle": "Córdoba Oro",
    "majorPlural": "Córdoba Oro",
    "symbol": "C$",
    "symbolNative": "C$",
    "symbolPreferred": "C$",
    "minorSingle": "Centavo",
    "minorPlural": "Centavos",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "NOK": {
    "name": "Norwegian Krone",
    "demonym": "Norwegian",
    "majorSingle": "Krone",
    "majorPlural": "Kroner",
    "symbol": "kr",
    "symbolNative": "kr",
    "symbolPreferred": "kr",
    "minorSingle": "øre",
    "minorPlural": "øre",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "NPR": {
    "name": "Nepalese Rupee",
    "demonym": "Nepalese",
    "majorSingle": "Rupee",
    "majorPlural": "Rupees",
    "symbol": "Rs.",
    "symbolNative": "रू",
    "symbolPreferred": "रू",
    "minorSingle": "Paisa",
    "minorPlural": "Paise",
    "decimals": 2,
    "decimalsCompact": 0,
    "digitGrouping": 2
  },
  "NZD": {
    "name": "New Zealand Dollar",
    "demonym": "New Zealand",
    "majorSingle": "Dollar",
    "majorPlural": "Dollars",
    "symbol": "NZ$",
    "symbolNative": "$",
    "symbolPreferred": "$",
    "minorSingle": "Cent",
    "minorPlural": "Cents",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "OMR": {
    "name": "Omani Rial",
    "demonym": "Omani",
    "majorSingle": "Rial",
    "majorPlural": "Rials",
    "symbol": "OR",
    "symbolNative": "ر.ع.",
    "symbolPreferred": "ر.ع.",
    "minorSingle": "Baisa",
    "minorPlural": "Baisa",
    "decimals": 3,
    "decimalsCompact": 3,
    "digitGrouping": 3
  },
  "PAB": {
    "name": "Panamanian Balboa",
    "demonym": "Panamanian",
    "majorSingle": "Balboa",
    "majorPlural": "Balboa",
    "symbol": "B/.",
    "symbolNative": "B/.",
    "symbolPreferred": "B/.",
    "minorSingle": "Centésimo",
    "minorPlural": "Centésimos",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "PEN": {
    "name": "Peruvian Sol",
    "demonym": "Peruvian",
    "majorSingle": "Sol",
    "majorPlural": "Soles",
    "symbol": "S/.",
    "symbolNative": "S/.",
    "symbolPreferred": "S/.",
    "minorSingle": "Céntimo",
    "minorPlural": "Céntimos",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "PGK": {
    "name": "Papua New Guinean Kina",
    "demonym": "Papua New Guinean",
    "majorSingle": "Kina",
    "majorPlural": "Kina",
    "symbol": "K",
    "symbolNative": "K",
    "symbolPreferred": "K",
    "minorSingle": "Toea",
    "minorPlural": "Toea",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "PHP": {
    "name": "Philippine Peso",
    "demonym": "Philippine",
    "majorSingle": "Peso",
    "majorPlural": "Pesos",
    "symbol": "₱",
    "symbolNative": "₱",
    "symbolPreferred": "₱",
    "minorSingle": "Sentimo",
    "minorPlural": "Sentimo",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "PKR": {
    "name": "Pakistani Rupee",
    "demonym": "Pakistani",
    "majorSingle": "Rupee",
    "majorPlural": "Rupees",
    "symbol": "Rs.",
    "symbolNative": "Rs",
    "symbolPreferred": "Rs",
    "minorSingle": "Paisa",
    "minorPlural": "Paise",
    "decimals": 2,
    "decimalsCompact": 0,
    "digitGrouping": 2
  },
  "PLN": {
    "name": "Polish Zloty",
    "demonym": "Polish",
    "majorSingle": "Zloty",
    "majorPlural": "Zlotys",
    "symbol": "zł",
    "symbolNative": "zł",
    "symbolPreferred": "zł",
    "minorSingle": "Grosz",
    "minorPlural": "Groszy",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "PYG": {
    "name": "Paraguayan Guaraní",
    "demonym": "Paraguayan",
    "majorSingle": "Guaraní",
    "majorPlural": "Guaraníes",
    "symbol": "₲",
    "symbolNative": "₲",
    "symbolPreferred": "₲",
    "minorSingle": "Centimo",
    "minorPlural": "Centimos",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "QAR": {
    "name": "Qatari Riyal",
    "demonym": "Qatari",
    "majorSingle": "Riyal",
    "majorPlural": "Riyals",
    "symbol": "QR",
    "symbolNative": "ر.ق.",
    "symbolPreferred": "ر.ق.",
    "minorSingle": "Dirham",
    "minorPlural": "Dirhams",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "RON": {
    "name": "Romanian Leu",
    "demonym": "Romanian",
    "majorSingle": "Leu",
    "majorPlural": "Lei",
    "symbol": "L",
    "symbolNative": "L",
    "symbolPreferred": "L",
    "minorSingle": "Ban",
    "minorPlural": "Bani",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "RSD": {
    "name": "Serbian Dinar",
    "demonym": "Serbian",
    "majorSingle": "Dinar",
    "majorPlural": "Dinars",
    "symbol": "din",
    "symbolNative": "дин",
    "symbolPreferred": "дин",
    "minorSingle": "Para",
    "minorPlural": "Para",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "RUB": {
    "name": "Russian Ruble",
    "demonym": "Russian",
    "majorSingle": "Ruble",
    "majorPlural": "Rubles",
    "symbol": "₽",
    "symbolNative": "₽",
    "symbolPreferred": "₽",
    "minorSingle": "Kopek",
    "minorPlural": "Kopeks",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "RWF": {
    "name": "Rwandan Franc",
    "demonym": "Rwandan",
    "majorSingle": "Franc",
    "majorPlural": "Francs",
    "symbol": "FRw",
    "symbolNative": "R₣",
    "symbolPreferred": "R₣",
    "minorSingle": "Centime",
    "minorPlural": "Centimes",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "SAR": {
    "name": "Saudi Riyal",
    "demonym": "Saudi",
    "majorSingle": "Riyal",
    "majorPlural": "Riyals",
    "symbol": "SR",
    "symbolNative": "ر.س.",
    "symbolPreferred": "ر.س.",
    "minorSingle": "Halalah",
    "minorPlural": "Halalahs",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "SBD": {
    "name": "Solomon Islands Dollar",
    "demonym": "Solomon Islands",
    "majorSingle": "Dollar",
    "majorPlural": "Dollars",
    "symbol": "SI$",
    "symbolNative": "$",
    "symbolPreferred": "$",
    "minorSingle": "Cent",
    "minorPlural": "Cents",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "SCR": {
    "name": "Seychellois Rupee",
    "demonym": "Seychellois",
    "majorSingle": "Rupee",
    "majorPlural": "Rupees",
    "symbol": "Rs.",
    "symbolNative": "Rs",
    "symbolPreferred": "Rs",
    "minorSingle": "Cent",
    "minorPlural": "Cents",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "SDG": {
    "name": "Sudanese Pound",
    "demonym": "Sudanese",
    "majorSingle": "Pound",
    "majorPlural": "Pounds",
    "symbol": "£SD",
    "symbolNative": "ج.س.",
    "symbolPreferred": "ج.س.",
    "minorSingle": "Qirsh",
    "minorPlural": "Qirsh",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "SEK": {
    "name": "Swedish Krona",
    "demonym": "Swedish",
    "majorSingle": "Krona",
    "majorPlural": "Kronor",
    "symbol": "kr",
    "symbolNative": "kr",
    "symbolPreferred": "kr",
    "minorSingle": "Öre",
    "minorPlural": "Öre",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "SGD": {
    "name": "Singapore Dollar",
    "demonym": "Singapore",
    "majorSingle": "Dollar",
    "majorPlural": "Dollars",
    "symbol": "S$",
    "symbolNative": "$",
    "symbolPreferred": "$",
    "minorSingle": "Cent",
    "minorPlural": "Cents",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "SHP": {
    "name": "Saint Helena Pound",
    "demonym": "Saint Helena",
    "majorSingle": "Pound",
    "majorPlural": "Pounds",
    "symbol": "£",
    "symbolNative": "£",
    "symbolPreferred": "£",
    "minorSingle": "Penny",
    "minorPlural": "Pence",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "SLL": {
    "name": "Sierra Leonean Leone",
    "demonym": "Sierra Leonean",
    "majorSingle": "Leone",
    "majorPlural": "Leones",
    "symbol": "Le",
    "symbolNative": "Le",
    "symbolPreferred": "Le",
    "minorSingle": "Cent",
    "minorPlural": "Cents",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "SOS": {
    "name": "Somali Shilling",
    "demonym": "Somali",
    "majorSingle": "Shilling",
    "majorPlural": "Shillings",
    "symbol": "Sh.So.",
    "symbolNative": "Ssh",
    "symbolPreferred": "Ssh",
    "minorSingle": "Senti",
    "minorPlural": "Senti",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "SRD": {
    "name": "Surinamese Dollar",
    "demonym": "Surinamese",
    "majorSingle": "Dollar",
    "majorPlural": "Dollars",
    "symbol": "Sr$",
    "symbolNative": "$",
    "symbolPreferred": "$",
    "minorSingle": "Cent",
    "minorPlural": "Cents",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "SSP": {
    "name": "South Sudanese Pound",
    "demonym": "South Sudanese",
    "majorSingle": "Pound",
    "majorPlural": "Pounds",
    "symbol": "SS£",
    "symbolNative": "SS£",
    "symbolPreferred": "SS£",
    "minorSingle": "Qirsh",
    "minorPlural": "Qirsh",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "STD": {
    "name": "Sao Tomean Dobra",
    "demonym": "Sao Tomean",
    "majorSingle": "Dobra",
    "majorPlural": "Dobra",
    "symbol": "Db",
    "symbolNative": "Db",
    "symbolPreferred": "Db",
    "minorSingle": "Dobra",
    "minorPlural": "Dobra",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "SYP": {
    "name": "Syrian Pound",
    "demonym": "Syrian",
    "majorSingle": "Pound",
    "majorPlural": "Pounds",
    "symbol": "LS",
    "symbolNative": "ل.س.",
    "symbolPreferred": "ل.س.",
    "minorSingle": "Qirsh",
    "minorPlural": "Qirsh",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "SZL": {
    "name": "Swazi Lilangeni",
    "demonym": "Swazi",
    "majorSingle": "Lilangeni",
    "majorPlural": "Emalangeni",
    "symbol": "L",
    "symbolNative": "L",
    "symbolPreferred": "L",
    "minorSingle": "Cent",
    "minorPlural": "Cents",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "THB": {
    "name": "Thai Baht",
    "demonym": "Thai",
    "majorSingle": "Baht",
    "majorPlural": "Baht",
    "symbol": "฿",
    "symbolNative": "฿",
    "symbolPreferred": "฿",
    "minorSingle": "Satang",
    "minorPlural": "Satang",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "TJS": {
    "name": "Tajikistani Somoni",
    "demonym": "Tajikistani",
    "majorSingle": "Somoni",
    "majorPlural": "Somoni",
    "symbol": "SM",
    "symbolNative": "SM",
    "symbolPreferred": "SM",
    "minorSingle": "Diram",
    "minorPlural": "Diram",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "TMT": {
    "name": "Turkmenistan Manat",
    "demonym": "Turkmenistan",
    "majorSingle": "Manat",
    "majorPlural": "Manat",
    "symbol": "m.",
    "symbolNative": "T",
    "symbolPreferred": "T",
    "minorSingle": "Tenge",
    "minorPlural": "Tenge",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "TND": {
    "name": "Tunisian Dinar",
    "demonym": "Tunisian",
    "majorSingle": "Dinar",
    "majorPlural": "Dinars",
    "symbol": "DT",
    "symbolNative": "د.ت.",
    "symbolPreferred": "د.ت.",
    "minorSingle": "Millime",
    "minorPlural": "Millime",
    "decimals": 3,
    "decimalsCompact": 3,
    "digitGrouping": 3
  },
  "TOP": {
    "name": "Tongan Paʻanga",
    "demonym": "Tongan",
    "majorSingle": "Pa'anga",
    "majorPlural": "Pa'anga",
    "symbol": "T$",
    "symbolNative": "PT",
    "symbolPreferred": "PT",
    "minorSingle": "Seniti",
    "minorPlural": "Seniti",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "TRY": {
    "name": "Turkish Lira",
    "demonym": "Turkish",
    "majorSingle": "Lira",
    "majorPlural": "Lira",
    "symbol": "TL",
    "symbolNative": "₺",
    "symbolPreferred": "₺",
    "minorSingle": "Kuruş",
    "minorPlural": "Kuruş",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "TTD": {
    "name": "Trinidad and Tobago Dollar",
    "demonym": "Trinidad and Tobago",
    "majorSingle": "Dollar",
    "majorPlural": "Dollars",
    "symbol": "TT$",
    "symbolNative": "$",
    "symbolPreferred": "$",
    "minorSingle": "Cent",
    "minorPlural": "Cents",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "TWD": {
    "name": "New Taiwan Dollar",
    "demonym": "New Taiwan",
    "majorSingle": "Dollar",
    "majorPlural": "Dollars",
    "symbol": "NT$",
    "symbolNative": "圓",
    "symbolPreferred": "圓",
    "minorSingle": "Cent",
    "minorPlural": "Cents",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "TZS": {
    "name": "Tanzanian Shilling",
    "demonym": "Tanzanian",
    "majorSingle": "Shilling",
    "majorPlural": "Shillings",
    "symbol": "TSh",
    "symbolNative": "TSh",
    "symbolPreferred": "TSh",
    "minorSingle": "Senti",
    "minorPlural": "Senti",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "UAH": {
    "name": "Ukrainian Hryvnia",
    "demonym": "Ukrainian",
    "majorSingle": "Hryvnia",
    "majorPlural": "Hryvnias",
    "symbol": "₴",
    "symbolNative": "грн",
    "symbolPreferred": "грн",
    "minorSingle": "Kopiyka",
    "minorPlural": "kopiyky",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "UGX": {
    "name": "Ugandan Shilling",
    "demonym": "Ugandan",
    "majorSingle": "Shilling",
    "majorPlural": "Shillings",
    "symbol": "USh",
    "symbolNative": "Sh",
    "symbolPreferred": "Sh",
    "minorSingle": "Cent",
    "minorPlural": "Cents",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "USD": {
    "name": "United States Dollar",
    "demonym": "US",
    "majorSingle": "Dollar",
    "majorPlural": "Dollars",
    "symbol": "$",
    "symbolNative": "$",
    "symbolPreferred": "$",
    "minorSingle": "Cent",
    "minorPlural": "Cents",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "UYU": {
    "name": "Uruguayan Peso",
    "demonym": "Uruguayan",
    "majorSingle": "Peso",
    "majorPlural": "Pesos",
    "symbol": "$U",
    "symbolNative": "$",
    "symbolPreferred": "$",
    "minorSingle": "Centésimo",
    "minorPlural": "Centésimos",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "UZS": {
    "name": "Uzbekistani Som",
    "demonym": "Uzbekistani",
    "majorSingle": "Som",
    "majorPlural": "Som",
    "symbol": "сум",
    "symbolNative": "сум",
    "symbolPreferred": "сум",
    "minorSingle": "Tiyin",
    "minorPlural": "Tiyin",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "VEF": {
    "name": "Venezuelan Fuerte",
    "demonym": "Venezuelan",
    "majorSingle": "Fuerte",
    "majorPlural": "Fuerte",
    "symbol": "Bs.",
    "symbolNative": "Bs.",
    "symbolPreferred": "Bs.",
    "minorSingle": "céntimo",
    "minorPlural": "céntimo",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "VND": {
    "name": "Vietnamese Dong",
    "demonym": "Vietnamese",
    "majorSingle": "Dong",
    "majorPlural": "Dong",
    "symbol": "₫",
    "symbolNative": "₫",
    "symbolPreferred": "₫",
    "minorSingle": "Hào",
    "minorPlural": "Hào",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "VUV": {
    "name": "Vanuatu Vatu",
    "demonym": "Vanuatu",
    "majorSingle": "Vatu",
    "majorPlural": "Vatu",
    "symbol": "VT",
    "symbolNative": "VT",
    "symbolPreferred": "VT",
    "minorSingle": "",
    "minorPlural": "",
    "decimals": 0,
    "decimalsCompact": 0,
    "digitGrouping": 3
  },
  "WST": {
    "name": "Samoan Tala",
    "demonym": "Samoan",
    "majorSingle": "Tala",
    "majorPlural": "Tala",
    "symbol": "T",
    "symbolNative": "ST",
    "symbolPreferred": "ST",
    "minorSingle": "Sene",
    "minorPlural": "Sene",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "XAF": {
    "name": "Central African CFA Franc BEAC",
    "demonym": "Central African CFA",
    "majorSingle": "Franc",
    "majorPlural": "Francs",
    "symbol": "Fr",
    "symbolNative": "Fr.",
    "symbolPreferred": "Fr.",
    "minorSingle": "Centime",
    "minorPlural": "Centimes",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "XCD": {
    "name": "East Caribbean Dollar",
    "demonym": "East Caribbean",
    "majorSingle": "Dollar",
    "majorPlural": "Dollars",
    "symbol": "$",
    "symbolNative": "$",
    "symbolPreferred": "$",
    "minorSingle": "Cent",
    "minorPlural": "Cents",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "XOF": {
    "name": "West African CFA Franc BCEAO",
    "demonym": "West African CFA",
    "majorSingle": "Franc",
    "majorPlural": "Francs",
    "symbol": "₣",
    "symbolNative": "₣",
    "symbolPreferred": "₣",
    "minorSingle": "Centime",
    "minorPlural": "Centimes",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "XPF": {
    "name": "CFP Franc (Franc Pacifique)",
    "demonym": "CFP",
    "majorSingle": "Franc",
    "majorPlural": "Francs",
    "symbol": "₣",
    "symbolNative": "₣",
    "symbolPreferred": "₣",
    "minorSingle": "Centime",
    "minorPlural": "Centimes",
    "decimals": 0,
    "decimalsCompact": 0,
    "digitGrouping": 3
  },
  "YER": {
    "name": "Yemeni Rial",
    "demonym": "Yemeni",
    "majorSingle": "Rial",
    "majorPlural": "Rials",
    "symbol": "YR",
    "symbolNative": "ر.ي.",
    "symbolPreferred": "ر.ي.",
    "minorSingle": "Fils",
    "minorPlural": "Fils",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "ZAR": {
    "name": "South African Rand",
    "demonym": "South African",
    "majorSingle": "Rand",
    "majorPlural": "Rand",
    "symbol": "R",
    "symbolNative": "R",
    "symbolPreferred": "R",
    "minorSingle": "Cent",
    "minorPlural": "Cents",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "ZMK": {
    "name": "Zambian Kwacha",
    "demonym": "Zambian",
    "majorSingle": "Kwacha",
    "majorPlural": "Kwacha",
    "symbol": "ZK",
    "symbolNative": "ZK",
    "symbolPreferred": "ZK",
    "minorSingle": "Ngwee",
    "minorPlural": "Ngwee",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  },
  "ZWL": {
    "name": "Zimbabwean Dollar",
    "demonym": "Zimbabwean",
    "majorSingle": "Dollar",
    "majorPlural": "Dollars",
    "symbol": "Z$",
    "symbolNative": "$",
    "symbolPreferred": "$",
    "minorSingle": "Cent",
    "minorPlural": "Cents",
    "decimals": 2,
    "decimalsCompact": 2,
    "digitGrouping": 3
  }
}